import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EntryType, Order } from 'src/app/cart/cart.model';
import { CartState } from './state';

export const selectCart = createFeatureSelector<CartState>('cart');

export const selectCartEditingItem = createSelector(
  selectCart,
  cart => cart.editCartItem,
);

export const selectCartModel = createSelector(
  selectCart,
  cart => cart.cart
)

export const selectOrder = createSelector(
  selectCart,
  cart => cart.order
)

export const selectCartItemCount = createSelector(
  selectCart,
  cart => cart.cart?.items.filter(i =>
    // don't count discount as an item
    i.entryType !== EntryType.Discount &&
    // don't count recurrence group, except if it's collapsed
    (i.entryType !== EntryType.RecurrenceGroup || i.collapseRecurrence)
  ).length
)

export const selectCheckoutGenericFields = createSelector(
  selectCart,
  cart => cart.checkoutFields
)

export const selectOrderFormModel = createSelector(
  selectOrder,
  order => {
    if (!order) return null

    return MapOrderToOrderFormModel(order)
  }
)

export function MapOrderToOrderFormModel(order: Order): { [key: string]: string | boolean } {
  const model = {
    ...order.customer,
    additionalNotes: order.additionalNotes,
    purpose: order.purpose,
    adminComment: order.adminComment,
    state: order.status,
    paymentMethod: order.paymentMethod,
    readonly: order.readonly
  } as { [key: string]: string | boolean }

  Object.entries(order.orderFields).forEach(([fieldId, value]) => model[fieldId] = value)

  return model
}
